import React from 'react';
import { QueryOptionsApi } from './QueryOptionsApi';
import useQuery from './useQuery';

interface QueryResult<T> {
    data: T;
    status: number | undefined;
    error: Error | undefined;
    loading: boolean;
    refetch: () => Promise<any>;
    clearCache: () => void;
    __initialized: boolean;
}

interface QueryOptions {
    api?: QueryOptionsApi;
    skip?: boolean;
}

export default function useCachedQuery<T extends {} = any>(
    url: string,
    initialData: any = undefined,
    options: QueryOptions = {}
): QueryResult<T> {
    const query = useQuery(url, initialData, {
        api: options?.api,
        useCache: true,
        skip: options?.skip,
    });

    return React.useMemo(() => query, [query.data, query.error, query.loading]);
}
